// F5-2 五图2
import { FC } from 'react'
import clsx from 'clsx'
import { IMutipleMedia, paddingTopClassMap, paddingBottomClassMap } from '@/common/pd-meta-components-types'
import PdMedia from '@/components/pd-media/pd-media'
import useScrollScale from '@/hooks/tools/use-scroll-scale'
import { useMobileDetector } from '@/hooks/use-mobile-detector'
import TitleAndDesc from '../../title-and-desc'
import TagItem from '../../tag-item'

const MainAndFourSubMedia: FC<IMutipleMedia> = ({ title, desc, mediaGroup, theme, mediaBorderRadius = 0, paddingTop = 'px120', paddingBottom = 'px120' }) => {
  const containerRef = useScrollScale({
    targetSelector: '.target-f5-2',
  })
  const isMobile = useMobileDetector()

  return (
    <div className={clsx('w-full h-fit', paddingTopClassMap[paddingTop], paddingBottomClassMap[paddingBottom], `pd-theme-${theme}`, 'bg-container-primary')}>
      <div className={clsx('w-full max-w-300 mx-auto')}>
        <TitleAndDesc title={title} desc={desc} />
        <div
          className={clsx('grid grid-cols-2 gap-x-3 gap-y-12', 'laptop:grid-cols-4 laptop:gap-x-6', 'px-6 laptop:px-0')}
        >
          {mediaGroup?.map((item, index) => (
            <div
              className={clsx('relative', index === 0 ? 'col-span-2 laptop:col-span-4' : 'col-span-1')}
              key={item.title}
            >
              <div
                className={clsx('w-full overflow-hidden', 'mb-3 laptop:mb-6')}
                style={{ aspectRatio: index === 0 ? '2/1' : '1/1', borderRadius: `${mediaBorderRadius}px` }}
                ref={index === 0 ? containerRef : null}
              >
                <PdMedia
                  src={isMobile ? item.mediaH5Url || item.mediaUrl || '' : item.mediaUrl || ''}
                  mask={false}
                  className={clsx(
                    index === 0
                      ? 'scale-150 target-f5-2'
                      : 'transition-all ease-in-out duration-[800ms] hover:scale-110'
                  )}
                />
              </div>
              <TagItem title={item.title} desc={item.desc} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default MainAndFourSubMedia
